module.exports = __webpack_public_path__ + "static/media/__Social.e40ce634.svg";